import { ApiResponseType, RequestOptions } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export interface DepositAccountInternationalType {
  name: string;
  bank_swift_code: string;
  bank_phone_number: string;
  intermediary_bank_phone_number: string;
  recipient_name: string;
  bank_name: string;
  bank_account_number: string;
  bank_address: string;
  intermediary_bank_swift_code: string;
  intermediary_bank_name: string;
  intermediary_bank_account_number: string;
  intermediary_bank_address: string;
}

export type ResponseType = {
  created_by: {
    id: string;
    email: string;
  };
  date_created: string;
  date_modified: string;
  id: string;
  name: string;
  ref_id: string;
  status: string;
};

export const createInternationalDepositAccountApi = (
  data: DepositAccountInternationalType,
  options: RequestOptions
): Promise<ApiResponseType<ResponseType>> => {
  const uri = '/organization/deposit-accounts/international/';

  return authApiService.POST(uri, data, null, options);
};
